import type { Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { StormDrainageAssetService } from '#/app/shared/services/api/storm-drainage-asset.service';

import { resolveResourceAccessGuardResult } from './resource-access-guard';

/**
 * Guard that verifies a storm drainage asset exists and belongs to the tenant in the route.
 * Prevents route matching if the asset doesn't exist or belongs to a different tenant,
 * allowing fallback routes to handle 404 display.
 */
export const stormDrainageAssetAccessCanMatchGuard: CanMatchFn = (
  _routes,
  _segments,
  _currentSnapshot,
) => {
  const stormDrainageAssetService = inject(StormDrainageAssetService);
  const assetIdParam = _currentSnapshot?.paramMap.get('assetId') ?? '';

  return resolveResourceAccessGuardResult(assetIdParam, (assetIdSignal) =>
    stormDrainageAssetService.stormDrainageAssetResource(
      assetIdSignal as Signal<string>,
    ),
  );
};
